Main modal
<div
  class="fixed top-0 left-0 right-0 z-50 items-center justify-center w-full overflow-x-hidden overflow-y-auto md:inset-0 h-modal h-full flex bg-[#4B556380]">
  <div class="relativew-full max-w-2xl w-full h-auto sm:px-0 px-4">
    <!-- Modal content -->
    <div class="relative bg-white rounded-lg shadow">
      <div class="flex p-4 sm:p-5 justify-start rounded-t">
        <h3 class="text-lg font-semibold text-gray-900">Technical Support</h3>
      </div>
      <!-- Modal body -->
      <div class="border-y-1 border-gray-200">
        <div class="p-5">
          <form class="space-y-4" [formGroup]="form">
            @if (errorMessage()) {
              <p class="mt-2 text-sm text-red-600">{{ errorMessage() }}</p>
            }
            <div>
              <label
                for="subject"
                class="block mb-2 text-sm font-medium text-gray-900"
                >What is your subject?</label
              >
              <input
                type="text"
                id="subject"
                formControlName="subject"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                required />
              <div class="h-5 mt-1 text-sm text-red-600 space-y-2">
                @if (
                  form.get('subject')?.dirty && form.get('subject')?.errors
                ) {
                  @if (form.get('subject')?.hasError('required')) {
                    Subject is required
                  }
                }
              </div>
            </div>

            <div>
              <label
                for="message"
                class="block mb-2 text-sm font-medium text-gray-900"
                >Describe in details your issue</label
              >
              <textarea
                id="message"
                formControlName="message"
                rows="6"
                maxlength="2000"
                class="block mb-2 p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"></textarea>
              <p class="text-sm text-gray-500" [class.text-red-500]="false">
                Message include max 2000 characters.
              </p>
              <div class="h-5 mt-1 text-sm text-red-600 space-y-2">
                @if (
                  form.get('message')?.dirty && form.get('description')?.errors
                ) {
                  @if (form.get('message')?.hasError('required')) {
                    Message is required
                  }
                }
              </div>
            </div>

            @if (imgSrc()) {
              <a
                class="inline-block max-w-[140px] max-h-[80px]"
                [href]="imgSrc()"
                target="_blank">
                <img
                  [src]="imgSrc()"
                  alt="image preview"
                  width="140"
                  height="80"
                  class="w-full h-full max-h-[80px]" />
              </a>
            }

            <div class="flex items-center gap-4">
              <button
                type="button"
                class="text-sm text-white font-medium py-2.5 px-5 bg-primary-700 border border-primary-700 hover:bg-primary-800 rounded-lg"
                (click)="openFilePicker()">
                Upload image
              </button>
              @if (fileData()) {
                <button
                  type="button"
                  class="text-sm text-gray-900 font-medium py-2.5 px-5 bg-white border border-gray-200 hover:bg-gray-200 rounded-lg"
                  (click)="removeFile()">
                  Remove image
                </button>
              }
              <icaredx-file-input></icaredx-file-input>
            </div>
          </form>
        </div>
      </div>
      <div class="flex items-center space-y-0 flex space-x-4 p-4 sm:p-5">
        <button
          type="button"
          class="text-white inline-flex justify-center items-center sm:w-auto bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:bg-gray-100 disabled:text-gray-500 cursor-pointer"
          (click)="submit()"
          [disabled]="(form.dirty && !form.valid) || isLoading()">
          @if (isLoading()) {
            <div role="status" class="w-full flex justify-center items-center">
              <svg
                aria-hidden="true"
                class="w-5 h-5 text-gray-500 animate-spin fill-white"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor" />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill" />
              </svg>
              <span class="sr-only">Loading...</span>
            </div>
          } @else {
            Send
          }
        </button>
        <button
          type="button"
          class="inline-flex justify-center items-center sm:w-auto text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-primary-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 cursor-pointer"
          (click)="discard()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
